import React, { useContext, useMemo } from 'react';
import Chart from 'react-apexcharts';
import { FiArrowUpRight } from 'react-icons/fi';
import { CashContext } from '../data/cash/CashContext';

const DonutChart = ({ unit = "₺", height = "270px", donutSize = "65%", children }) => {
  const { cashList } = useContext(CashContext);

  // Gelir/Gider ve kategori hesaplamaları
  const { series, categories, totalTransaction, netBalance } = useMemo(() => {
    let income = 0;
    let expense = 0;

    const categoryMap = {};

    cashList.forEach(item => {
      const amount = Number(item.amount) || 0;
      if (item.paymentDirection === "Gelir") income += amount;
      else if (item.paymentDirection === "Gider") expense += amount;

      // Kategori bazlı toplam
      const cat = item.paymentDirection || "Diğer";
      categoryMap[cat] = (categoryMap[cat] || 0) + amount;
    });

    const seriesArr = Object.values(categoryMap);
    const categoriesArr = Object.keys(categoryMap);

    return {
      series: seriesArr,
      categories: categoriesArr,
      totalTransaction: income + expense,
      netBalance: income - expense
    };
  }, [cashList]);

  // ApexCharts ayarları
  const options = {
    chart: { type: 'donut', toolbar: { show: false }, background: "#fff", foreColor: "#000" },
    labels: categories,
    colors: ['#0d6efd', '#fd7e14', '#8C8E90FF', '#198754', '#6f42c1'], 
    legend: { show: true, position: 'bottom', horizontalAlign: 'center', markers: { width: 18, height: 18, radius: 18 } },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const total = series.reduce((sum, v) => sum + v, 0);
        const value = series[opts.seriesIndex];
        const percent = total > 0 ? (value / total * 100).toFixed(1) : 0;
        return `${percent}%`;
      }
    },
    tooltip: { y: { formatter: val => `${val.toLocaleString()} ${unit}` } },
    plotOptions: { pie: { donut: { size: donutSize } } }
  };

  return (
    <div 
      className="card p-0 cash-card m-0 mb-0"
      style={{ 
        border: "1px solid #E4E4E4FF",
        borderRadius: "8px"
      }}
    >
      <h5 style={{fontSize:'20px',marginLeft:'20px ',marginTop:6}}>Kasa Bakiyesi</h5>
      <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px',marginLeft:'20px ' }}>
        Kasa bakiyesi ve nakit artışı anlık olarak görülebilir
      </div>

      <div className="d-flex flex-wrap align-items-start mt-3 gap-4 cash-card-content">
        {/* Sol: Donut Chart */}
        <div className="cash-donut-wrapper" style={{ position: 'relative', flex: '1 1 45%', minWidth: '0px' }}>
          <Chart options={options} series={series} type="donut" height={height} width="100%" />
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '18px', color: '#6c757d', marginBottom:'6px' }}>Toplam İşlem</div>
            <div style={{ fontSize: '22px', fontWeight: 'bold', marginBottom:'5px' }}>
              {totalTransaction.toLocaleString()} {unit}
            </div>
          </div>
        </div>

        {/* Sağ: Finansal Bilgi */}
        <div className="cash-info-wrapper flex-grow-1">
          <div className="d-flex align-items-center gap-2 mb-3 flex-wrap mt-5">
            <div>
              <div style={{ fontSize: '28px', color: '#6c757d' }}>Net Bakiye</div>
              <div style={{ fontSize: '25px', fontWeight: 'bold' }}>
                {netBalance.toLocaleString()} {unit}
              </div>
            </div>
            <FiArrowUpRight size={24} color={netBalance >= 0 ? "green" : "red"} />
          </div>

          {/* Alt: Renkli kategori kutuları */}
          <div className="d-flex flex-column align-items-start gap-2 mt-2">
            {categories.map((cat, idx) => (
              <div key={cat} className="d-flex align-items-center gap-1 mb-1">
                <div style={{
                  width: '15px',
                  height: '15px',
                  backgroundColor: options.colors[idx % options.colors.length],
                  borderRadius:'3px'
                }}></div>
                <span style={{ fontSize: '12px' }}>{cat}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Grafik altına tablo(children) gelecek */}
      <div className="mt-4">
        {children}
      </div>
    </div>
  );
};

export default DonutChart;
